import { Component } from "react";

export class GtaxErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    window.__reportError?.(error?.message, `${error?.stack || ""}\n${info?.componentStack || ""}`);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", background: "#EFE4CF", color: "#1E1A14", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center", fontFamily: "Georgia, serif" }} data-testid="gtax-error-fallback">
        <img src="/gtax/logo.png" alt="GTA X" style={{ width: 120, height: 120 }} />
        <h1 style={{ fontSize: 32, marginTop: 24, color: "#1E1A14" }}>GTA X</h1>
        <p style={{ marginTop: 12, color: "#6B5F4B", maxWidth: 420 }}>This page needs a quick refresh.</p>
        <button onClick={() => window.location.reload()} data-testid="gtax-error-reload"
          style={{ marginTop: 24, padding: "14px 32px", borderRadius: 999, border: "none", background: "#B8892B", color: "#1E1A14", letterSpacing: 2, fontSize: 14 }}>
          RELOAD
        </button>
      </div>
    );
  }
}
